import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { RiArrowLeftLine, RiArrowRightLine } from "react-icons/ri";
import { getAchievementImage } from "../cms/achievements";
import { useCmsAchievement } from "../cms/useCmsContent";

export default function AchievementDetailPage() {
  const { slug } = useParams();
  const { achievement, isLoading } = useCmsAchievement(slug);

  useEffect(() => {
    if (achievement?.title) {
      document.title = `${achievement.title} - Réalisation Fatihoune`;
    }
  }, [achievement]);

  if (isLoading) {
    return (
      <main className="container py-10 text-center">
        <span className="spinner-border text-primary" />
      </main>
    );
  }

  if (!achievement) {
    return (
      <main className="container py-10">
        <p className="section-kicker mb-3">Mission introuvable</p>
        <h1 className="section-heading mb-4">Cette mission n'est pas disponible.</h1>
        <Link to="/realisations" className="btn btn-outline-dark">
          Retour aux missions
        </Link>
      </main>
    );
  }

  return (
    <main>
      <section className="mission-detail-hero">
        <div className="container">
          <Link to="/realisations" className="mission-back-link">
            <RiArrowLeftLine aria-hidden="true" />
            Toutes les missions
          </Link>
          <div className="mission-detail-grid">
            <div>
              <p className="section-kicker mb-3">
                {[achievement.category, achievement.country, achievement.year]
                  .filter(Boolean)
                  .join(" · ") || "Réalisation"}
              </p>
              <h1 className="section-heading mb-4">{achievement.title}</h1>
              <p className="mission-detail-lead">{achievement.description}</p>
            </div>
            <div className="mission-detail-image">
              <img src={getAchievementImage(achievement)} alt={achievement.title} />
            </div>
          </div>
        </div>
      </section>

      <section className="container py-7">
        <div className="mission-detail-content">
          <aside className="mission-detail-aside">
            <div>
              <span>Client / contexte</span>
              <strong>{achievement.clientName || "Mission Fatihoune"}</strong>
            </div>
            <div>
              <span>Zone</span>
              <strong>{achievement.country || "Non précisée"}</strong>
            </div>
            <div>
              <span>Année</span>
              <strong>{achievement.year || "Non précisée"}</strong>
            </div>
          </aside>

          <article className="mission-detail-panel">
            <p className="section-kicker mb-3">Résultat</p>
            <h2>Ce que la mission a permis de structurer</h2>
            <p>
              {achievement.result ||
                "La mission a permis de clarifier le besoin, d'organiser les priorités et de produire une base de travail exploitable par les équipes."}
            </p>

            {achievement.metrics?.length > 0 && (
              <div className="mission-detail-metrics">
                {achievement.metrics.map((metric) => (
                  <div key={`${metric.value}-${metric.label}`}>
                    <strong>{metric.value}</strong>
                    <span>{metric.label}</span>
                  </div>
                ))}
              </div>
            )}
          </article>
        </div>

        <div className="mission-next-step">
          <div>
            <p className="section-kicker mb-2">Prochaine étape</p>
            <h2>Vous voulez cadrer une mission comparable ?</h2>
          </div>
          <Link to="/contact" className="btn btn-success">
            Qualifier ma demande
            <RiArrowRightLine aria-hidden="true" />
          </Link>
        </div>
      </section>
    </main>
  );
}
